export default {
    set: ({ key, value, expiry, path, secure, samesite, domain, max_age }) => {
        if (!key) {
            throw 'must provide key'
        }

        var cookie = `${key}=`

        if (typeof value === 'object') {
            cookie += `${JSON.stringify(value)};`
        } else {
            cookie += `${value};`
        }

        if (expiry) {
            if (expiry instanceof Date) {
                cookie += ` ;expires=${expiry.toUTCString()};`
            } else {
                throw 'expiry must be a Date object'
            }
        }

        cookie += ` ;path=${path || '/'};`

        if (domain) {
            cookie += ` ;domain=${domain};`
        }

        if (max_age) {
            if (Number.isInteger(max_age)) {
                cookie += ` ;max-age=${domain};`
            } else {
                throw 'max_age must be an integer and represents seconds'
            }
        }

        if (secure === true) {
            cookie += ' ;secure;'
        }

        if (samesite) {
            if (samesite === 'strict' || samesite === 'Strict') {
                cookie += ' ;SameSite=Strict;'
            } else if (samesite === 'lax' || samesite === 'Lax') {
                cookie += ' ;SameSite=Lax;'
            } else if (samesite === 'none' || samesite === 'None') {
                cookie += ' ;SameSite=None;'
            } else {
                throw 'samesite must be set to "none", "strict", "lax" or not at all'
            }
        }

        document.cookie = cookie
    },
    get: (key) => {
        var name = key + '='
        var decodedCookie = decodeURIComponent(document.cookie)
        var cookies = decodedCookie.split(';')
        for (var i = 0; i < cookies.length; i++) {
            var c = cookies[i]
            while (c.charAt(0) == ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) == 0) {
                var cookie_value = c.substring(name.length, c.length)
                return cookie_value
            }
        }
        return null
    },
    delete(key, path) {
        var expiry = new Date()
        expiry.setDate(expiry.getDate() - 5)
        this.set({
            key: key,
            value: '',
            expiry: expiry,
            path: path
        })
    }
}
